// Use persons-or-vehicles-section.tsx as reference
// There will be one property section, where we will be able to map & list all different properties by firearm, drug, then otherItem
// Start there first.
import { VStack, Button } from '@cad-arc';
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { EntityTypes, Entity, MergedEntityTypes } from '../fr-entity-panels/types';
import { SectionTitle } from './section-title';
import { EntityCard } from './fr-event-summary-entities-and-reports/components/entity-card';
import { FR_ADD_EVENT_PROPERTY_SUB_PATH, FR_EVENT_ROOT_PATH } from '../router/constants';

export function InvolvedPropertySection({
    title,
    firearmsList,
    mergedFirearmsList,
    drugsList,
    mergedDrugsList,
    otherItemsList,
    mergedOtherItemsList,
    showDexDetails = true,
    eventId,
}: {
    eventId: number | undefined;
    title: string;
    firearmsList: Entity[];
    mergedFirearmsList: Entity[];
    drugsList: Entity[];
    mergedDrugsList: Entity[];
    otherItemsList: Entity[];
    mergedOtherItemsList: Entity[];
    showDexDetails?: boolean;
}) {
    const navigate = useNavigate();
    const navigateToAddEvent = useCallback(() => {
        navigate(`${FR_EVENT_ROOT_PATH}/${eventId}/${FR_ADD_EVENT_PROPERTY_SUB_PATH}`);
    }, [navigate, eventId]);
    return (
        <VStack alignItems="flex-start" w="100%">
            <SectionTitle title={title} />
            {firearmsList?.length > 0 &&
                firearmsList.map((entity: Entity, index: number) => {
                    return (
                        <EntityCard
                            // @ts-expect-error: key might be a different property if the entity is a either a firearm, drug, or other item
                            key={entity['id']}
                            entity={entity}
                            type={EntityTypes.FIREARMS}
                            index={index}
                            showDexDetails={showDexDetails}
                        />
                    );
                })}
            {mergedFirearmsList?.length > 0 &&
                mergedFirearmsList.map((entity: Entity, index: number) => {
                    return (
                        <EntityCard
                            // @ts-expect-error: key might be a different property if the entity is a either a firearm, drug, or other item
                            key={entity['id']}
                            entity={entity}
                            type={MergedEntityTypes.FIREARMS}
                            index={index}
                            showDexDetails={showDexDetails}
                        />
                    );
                })}
            {drugsList?.length > 0 &&
                drugsList.map((entity: Entity, index: number) => {
                    return (
                        <EntityCard
                            // @ts-expect-error: key might be a different property if the entity is a either a firearm, drug, or other item
                            key={entity['id']}
                            entity={entity}
                            type={EntityTypes.DRUGS}
                            index={index}
                            showDexDetails={false}
                        />
                    );
                })}
            {mergedDrugsList?.length > 0 &&
                mergedDrugsList.map((entity: Entity, index: number) => {
                    return (
                        <EntityCard
                            // @ts-expect-error: key might be a different property if the entity is a either a firearm, drug, or other item
                            key={entity['id']}
                            entity={entity}
                            type={MergedEntityTypes.DRUGS}
                            index={index}
                            showDexDetails={false}
                        />
                    );
                })}
            {otherItemsList?.length > 0 &&
                otherItemsList.map((entity: Entity, index: number) => {
                    return (
                        <EntityCard
                            // @ts-expect-error: key might be a different property if the entity is a either a firearm, drug, or other item
                            key={entity['id']}
                            entity={entity}
                            type={EntityTypes.OTHER_ITEMS}
                            index={index}
                            showDexDetails={showDexDetails}
                        />
                    );
                })}
            {mergedOtherItemsList?.length > 0 &&
                mergedOtherItemsList.map((entity: Entity, index: number) => {
                    return (
                        <EntityCard
                            // @ts-expect-error: key might be a different property if the entity is a either a firearm, drug, or other item
                            key={entity['id']}
                            entity={entity}
                            type={MergedEntityTypes.OTHER_ITEMS}
                            index={index}
                            showDexDetails={showDexDetails}
                        />
                    );
                })}
            {!firearmsList?.length &&
            !mergedFirearmsList?.length &&
            !drugsList?.length &&
            !mergedDrugsList?.length &&
            !otherItemsList?.length &&
            !mergedOtherItemsList?.length ? (
                <Button onClick={navigateToAddEvent} leadingVisual="Add" style={{ width: '100%' }}>
                    Add Property
                </Button>
            ) : (
                <Button onClick={navigateToAddEvent} style={{ width: '100%' }}>
                    Edit Property
                </Button>
            )}
        </VStack>
    );
}
